import {mappedColumnIds, prepareRowsToMarkersType} from '../utils';
import {ActionTypes, AdvancedDeliveryAction} from './actions';
import {AdvancedDeliveryContextType, defaultContext} from './model';

export type AdvancedDeliveryType = (
    state: AdvancedDeliveryContextType,
    action: AdvancedDeliveryAction
) => AdvancedDeliveryContextType;

export const advancedDeliveryReducer: AdvancedDeliveryType = (state, action) => {
    switch (action.type) {
        case ActionTypes.OPEN_ADP:
            return {...state, isADPOpen: true};

        case ActionTypes.CLOSE_ADP:
            return {...state, ...defaultContext};

        case ActionTypes.SET_SELECTED_MARKERS:
            return {...state, markers: action.payload};

        case ActionTypes.TOGGLE_SHOW_ROUTE:
            return {...state, routes: action.payload};

        case ActionTypes.TOGGLE_ROUTE_SELECT:
            return {...state, routes: action.payload};

        case ActionTypes.UNSELECT_ALL_ROUTES:
            return {...state, routes: action.payload};

        case ActionTypes.SET_PLANING_FORM:
            return {...state, planningForm: action.payload};

        case ActionTypes.SET_ROUTES_FORM:
            return {...state, routesForm: action.payload};

        case ActionTypes.SET_SHOW_PLANNED_LOCATIONS:
            return {...state, isShowPlannedLocations: action.payload};

        case ActionTypes.SET_SELECTED_LOCATIONS:
            return {...state, selectedLocations: action.payload};

        case ActionTypes.SET_ROUTES:
            return {...state, routes: action.payload.routes, showAll: action.payload.showAll};

        case ActionTypes.SET_ROUTE_COLOR:
            return {
                ...state,
                routes: state.routes.map(route =>
                    route.id === action.payload.routeId.toString()
                        ? {
                              ...route,
                              color: action.payload.color,
                              markers: route.markers.map((marker: any) => ({
                                  ...marker,
                                  color: action.payload.color
                              })),
                              startMarker: {
                                  ...route.startMarker,
                                  color: action.payload.color
                              },
                              endMarker: {
                                  ...route.endMarker,
                                  color: action.payload.color
                              }
                          }
                        : route
                )
            };

        case ActionTypes.SET_ROUTE_LOCATION_FORM_RELOAD:
            return {
                ...state,
                routes: state.routes.map(route =>
                    route.id === action.payload.routeId.toString()
                        ? {
                              ...route,
                              locationSubformReload: action.payload.value
                          }
                        : route
                )
            };

        case ActionTypes.SET_ROUTE_LOCATIONS:
            return {
                ...state,
                routes: state.routes.map(route =>
                    route.id === action.payload.routeId.toString()
                        ? {
                              ...route,
                              locations: action.payload.locations,
                              markers: route.locationSubform?.columns
                                  ? prepareRowsToMarkersType(
                                        action.payload.locations.map(location => location.data),
                                        mappedColumnIds(route.locationSubform.columns),
                                        route
                                    )
                                  : route.markers
                          }
                        : route
                )
            };

        case ActionTypes.SET_ROUTE_LOCATIONS_AND_FORM:
            return {
                ...state,
                routes: state.routes.map(route =>
                    route.id === action.payload.routeId.toString()
                        ? {
                              ...route,
                              locationSubform: action.payload.form,
                              locations: action.payload.locations,
                              markers: action.payload.form?.columns
                                  ? prepareRowsToMarkersType(
                                        action.payload.locations.map(location => location.data),
                                        mappedColumnIds(action.payload.form.columns),
                                        route
                                    )
                                  : route.markers
                          }
                        : route
                )
            };

        case ActionTypes.SET_ROUTE_COLLAPSABLE_OPEN:
            return {
                ...state,
                routes: state.routes.map(route =>
                    route.id === action.payload.routeId.toString()
                        ? {...route, isCollapsableOpen: action.payload.isCollapsableOpen}
                        : route
                )
            };

        case ActionTypes.SET_ROUTE_LOCATION_FORM:
            return {
                ...state,
                routes: state.routes.map(route =>
                    route.id === action.payload.routeId.toString()
                        ? {
                              ...route,
                              locationSubform: action.payload.form,
                              markers: route.locations?.length
                                  ? prepareRowsToMarkersType(
                                        route.locations.map(location => location.data),
                                        mappedColumnIds(action.payload.form.columns),
                                        route
                                    )
                                  : route.markers
                          }
                        : route
                )
            };

        case ActionTypes.SET_LOCATION_SUBFORM_OPEN:
            return {
                ...state,
                routes: state.routes.map(route =>
                    route.id === action.payload.routeId.toString()
                        ? {...route, locationSubformOpen: action.payload.locationSubformOpen}
                        : {...route}
                )
            };

        case ActionTypes.SET_ROUTE_LOCATION_FORM_LOADING:
            return {
                ...state,
                routes: state.routes.map(route =>
                    route.id === action.payload.routeId.toString()
                        ? {...route, locationSubformLoading: action.payload.loading}
                        : route
                )
            };

        case ActionTypes.SET_LOCATION_ITEMS:
            const route = state.routes.find(
                route => route.id === action.payload.routeId.toString()
            );
            if (route) {
                const location = route?.locations.find(
                    location => location.id === action.payload.locationId
                );
                if (location) {
                    location.items = action.payload.items;
                }
            }
            return state;

        case ActionTypes.SET_LOCATION_ITEM_FORM:
            return {
                ...state,
                routes: state.routes.map(route =>
                    route.id === action.payload.routeId.toString()
                        ? {
                              ...route,
                              locations: route.locations.map(location =>
                                  location.id === action.payload.locationId
                                      ? {...location, itemsSubform: action.payload.form}
                                      : location
                              )
                          }
                        : route
                )
            };

        case ActionTypes.SET_DISPLAYED_ROUTES:
            return {
                ...state,
                routes: action.payload.routesToDisplay,
                showAll: action.payload.showAll
            };

        default:
            return state;
    }
};
